import { render, staticRenderFns } from "./KeepSubscriptionDiscount.vue?vue&type=template&id=874254f0"
import script from "./KeepSubscriptionDiscount.vue?vue&type=script&lang=js"
export * from "./KeepSubscriptionDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmFieldPhone: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldPhone.vue').default,TlmFieldPassword: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldPassword.vue').default,ModalKeepSubscription: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Modal/KeepSubscription.vue').default})
